// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3OW1A","content":"content___2ktGp","actionBtn":"actionBtn___m9WQT"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/BuyAgainBar/index.modules.less
// module id = 758
// module chunks = 438